import { Badge } from '@/components/ui/Badge'
import { STATUS_LABEL, type FieldStatus } from '@/types/material'

const TONE: Record<FieldStatus, 'default' | 'brand' | 'ok' | 'warn' | 'danger'> = {
  provided_verified: 'ok',
  evidence_proven: 'ok',
  provided_unverified: 'warn',
  suspected: 'warn',
  model_only: 'warn',
  provided_conflict: 'danger',
  missing: 'danger',
  undetermined: 'default',
}

export function StatusBadge({ status }: { status: FieldStatus }) {
  return <Badge tone={TONE[status]}>{STATUS_LABEL[status]}</Badge>
}
